
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const Index = () => {
  const navigate = useNavigate();
  const { user, isLoading, userRole } = useAuth();

  useEffect(() => {
    // FIRST: Check for reset password tokens immediately (before auth loading completes)
    // This prevents tokens from expiring while we wait for auth state
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = hashParams.get('access_token');
    const type = hashParams.get('type');
    
    if (accessToken && type === 'recovery') {
      console.log('Reset password tokens detected, redirecting to reset page');
      // Redirect to reset password page with tokens preserved
      navigate(`/auth/reset-password${window.location.hash}`);
      return;
    }

    // SECOND: Handle normal authentication flow only after loading completes
    if (!isLoading) {
      if (user) {
        if (userRole === 'admin') {
          // If user is authenticated and is admin, redirect to dashboard
          navigate("/dashboard");
        } else {
          // If user is authenticated but not admin, show error and redirect to sign in
          toast.error("Access denied", { description: "Only admin users can access this portal" });
          navigate("/auth/sign-in");
        }
      } else {
        // If user is not authenticated, redirect to sign in
        navigate("/auth/sign-in");
      }
    }
  }, [navigate, user, isLoading, userRole]);

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return null;
};

export default Index;
